import { Reveal } from "./Reveal";

const KEYWORDS = ["Fabrication française", "Personnalisation", "Exigence du détail"];

export default function Signature() {
  return (
    <section
      id="signature"
      data-testid="signature-section"
      className="border-y border-[#E2DBCB]/10 bg-[#141619]/40 py-24 sm:py-28"
    >
      <div className="px-6 sm:px-12 lg:px-20 max-w-4xl mx-auto text-center">
        <Reveal>
          <p
            data-testid="signature-eyebrow"
            className="text-xs uppercase tracking-[0.35em] font-mono text-[#C5A059]"
          >
            Tarantina · Signature professionnelle
          </p>
          <h2 className="mt-8 font-serif text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight leading-snug">
            L'élégance n'est pas un détail.{" "}
            <em className="italic text-[#D4AF37]">C'est une signature.</em>
          </h2>
          <p className="mt-8 text-base sm:text-lg text-[#B0ABA0] leading-relaxed">
            Des peignoirs et kimonos de coiffure conçus pour les professionnels
            qui souhaitent offrir bien plus qu'une prestation : une véritable
            expérience.
          </p>
          <div
            data-testid="signature-keywords"
            className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[11px] font-mono uppercase tracking-[0.2em] text-[#75726B]"
          >
            {KEYWORDS.map((k, i) => (
              <span key={k} className="flex items-center gap-x-6">
                {i > 0 && (
                  <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/70" />
                )}
                {k}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
